<div *ngFor="let condition of dealConditionsMarkup">
    <div class="dc-content" [innerHTML]="condition.content | safeHtml"></div>
</div>
